module.exports = __webpack_public_path__ + "img/bmcl_main2.deaa00cc.jpg";